export default __webpack_public_path__ + "static/media/seminar211124.04a2336b.png";